import { useQuery } from '@tanstack/react-query';
import { contasPagarService } from '../services/contasPagarService';

export const useDetalheContaPagar = (id: number | null) =>
  useQuery({
    queryKey: ['conta-pagar-detalhe', id],
    queryFn: () => contasPagarService.getDetalhe(id!),
    enabled: id !== null && id > 0,
  });
